import React from 'react';
import { floatingActions } from './fullscreenOverlay.styles';
import type { FloatingActionsProps } from './types';

/**
 * FloatingActions Component
 *
 * Floating action buttons positioned on the sides for media variant.
 * Used for Save, Contact, Share buttons in the immersive view.
 *
 * @example Right-side floating actions
 * <FloatingActions position="right">
 *   <Button>Save</Button>
 *   <Button>Contact</Button>
 *   <Button>Share</Button>
 * </FloatingActions>
 */
export const FloatingActions = ({ children, position = 'right' }: FloatingActionsProps) => {
  return <div className={floatingActions({ position })}>{children}</div>;
};
